import { render, staticRenderFns } from "./PhieuThuTienPhong.vue?vue&type=template&id=50876344&scoped=true"
import script from "./PhieuThuTienPhong.vue?vue&type=script&lang=js"
export * from "./PhieuThuTienPhong.vue?vue&type=script&lang=js"
import style0 from "./PhieuThuTienPhong.vue?vue&type=style&index=0&id=50876344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50876344",
  null
  
)

export default component.exports